import { PlacementRiskSignals } from './risks_evaluation'

const filterableFields = [
    'placementName',
    'risksScore',
    'impressions',
    'clicks',
    'costMinis',
    'conversionsNativeMinis',
    'conversionsValueNativeMinis',
    // auto excluder categories
    'flaggedWords',
    'poorPerformance',
    ...Object.values(PlacementRiskSignals),
] as const
export type FilterableField = (typeof filterableFields)[number]
export const FilterableFields = new Set<FilterableField>(filterableFields)

const filterOperators = ['ilike', 'not ilike', '=', '>=', '<='] as const
export type FilterOperator = (typeof filterOperators)[number]
export const FilterOperators = new Set<FilterOperator>(filterOperators)

export type UserFilter = {
    field: FilterableField
    operator: FilterOperator
    value: string | number | boolean
}

const sortableFields = [
    'placementName',
    'risksScore',
    'impressions',
    'clicks',
    'costMinis',
    'conversionsNativeMinis',
    'conversionsValueNativeMinis',
] as const
export type SortableField = (typeof sortableFields)[number]
export const SortableFields = new Set<SortableField>(sortableFields)

const sortOrders = ['asc', 'desc'] as const
export type SortOrder = (typeof sortOrders)[number]
export const SortOrders = new Set<SortOrder>(sortOrders)

export type SortBy = {
    field: SortableField
    order: SortOrder
}
